export const EXECUTION_SECTIONS = [
  { id: 'rebalancer', label: 'Rebalancer' },
  { id: 'orders', label: 'Orders' },
  { id: 'trades', label: 'Trades' },
  { id: 'changes', label: 'Changes' },
  { id: 'confirmations', label: 'Confirmations' },
] as const;
export type ExecutionSection = (typeof EXECUTION_SECTIONS)[number]['id'];
export function executionSection(value: unknown): ExecutionSection {
  return EXECUTION_SECTIONS.some((s) => s.id === value)
    ? (value as ExecutionSection)
    : 'orders';
}
